// Versão: 1.00
// Data..: 2026-09-24
// Consultas a serviços públicos brasileiros (do navegador, sem chave): ViaCEP (endereço
// por CEP) e BrasilAPI (dados cadastrais por CNPJ). Usadas para autopreencher o
// cadastro de empresa. Falhas são tratadas pelo chamador (não quebram o formulário).

export interface CepResult {
  street?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
}

// Consulta o CEP no ViaCEP. Retorna undefined se inválido/não encontrado.
export async function lookupCep(cepRaw: string): Promise<CepResult | undefined> {
  const cep = cepRaw.replace(/\D/g, '');
  if (cep.length !== 8) return undefined;
  const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
  if (!res.ok) return undefined;
  const data = (await res.json()) as {
    erro?: boolean; logradouro?: string; bairro?: string; localidade?: string; uf?: string;
  };
  if (data.erro) return undefined;
  return {
    street: data.logradouro || undefined,
    neighborhood: data.bairro || undefined,
    city: data.localidade || undefined,
    state: data.uf || undefined,
  };
}

export interface CnpjResult {
  name?: string; // razão social / nome fantasia
  email?: string;
  phone?: string;
  cep?: string;
  street?: string;
  number?: string;
  complement?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
}

// Consulta o CNPJ na BrasilAPI. Retorna undefined se inválido/não encontrado.
export async function lookupCnpj(cnpjRaw: string): Promise<CnpjResult | undefined> {
  const cnpj = cnpjRaw.replace(/\D/g, '');
  if (cnpj.length !== 14) return undefined;
  const res = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);
  if (!res.ok) return undefined;
  const d = (await res.json()) as Record<string, unknown>;
  const str = (k: string) => (typeof d[k] === 'string' ? (d[k] as string).trim() : undefined);
  return {
    name: str('nome_fantasia') || str('razao_social'),
    email: str('email'),
    phone: str('ddd_telefone_1'),
    cep: str('cep'),
    street: str('logradouro'),
    number: str('numero'),
    complement: str('complemento'),
    neighborhood: str('bairro'),
    city: str('municipio'),
    state: str('uf'),
  };
}
